// Automation & Intelligence Section
import React from "react";
import { Col, Row } from "react-bootstrap";
import PandD from "../assets/PandD.svg";
import { motion } from "framer-motion";

function PDComponent() {
  return (
    <div className="section-pandD-wrapper">
      {/* Animated Background Elements */}
      <div className="intelligence-bg">
        {[...Array(6)].map((_, i) => (
          <motion.div
            key={i}
            className="neural-node"
            animate={{
              y: [0, -20, 0],
              opacity: [0.05, 0.15, 0.05],
            }}
            transition={{
              duration: 3 + i,
              repeat: Infinity,
              delay: i * 0.5,
            }}
            style={{
              left: `${15 + i * 15}%`,
              top: `${20 + (i % 3) * 20}%`,
            }}
          />
        ))}
      </div>

      <div className="container section-pandD">
        <Row className="align-items-center">
          <Col xs={12} lg={6}>
            <div className="text" style={{ opacity: 1 }}>
              <div className="section-badge section-badge-light">
                Automation &amp; Intelligence
              </div>
              <h2 className="display-4 fw-bold mb-4" style={{ color: "#0a1a12" }}>
                Systems That <span style={{ color: "#22a178" }}>Think</span> <br /> 
                So You Don't Have To.
              </h2>
              <p className="lead text-muted mb-4">
                At GoWave Automation Lab, we build AI-powered systems that
                eliminate repetitive work and surface intelligent insights.
              </p>
              <div className="feature-list">
                <div className="feature-item">
                  <span className="feature-icon">✔</span>
                  <span style={{ color: "#333" }}>Self-learning workflows</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✔</span>
                  <span style={{ color: "#333" }}>Predictive data analytics</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✔</span>
                  <span style={{ color: "#333" }}>24/7 Intelligent monitoring</span>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} lg={6}>
            <div className="dashboard-preview" style={{ opacity: 1 }}>
              <img
                src={PandD}
                alt="Automation illustration"
                className="img-fluid"
              />
              <div className="floating-ui-badge">AI Active</div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default PDComponent;
